import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  footer: {
    marginTop: 'auto',
    padding: 10,
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));
